import { v4 as generateGUID } from 'uuid';
import { setCookie, deleteCookie } from '@client/shared/utils/utils/utils';
import { HLF_SESSION, HLF_IDENTITY } from '@client/definitions/constants.js';

const setIdentityCookie = () => {
  const identity = document.cookie.includes(HLF_IDENTITY);
  if (!identity) setCookie(HLF_IDENTITY, generateGUID(), 365);
};

const setSessionCookie = () => {
  const session = document.cookie.includes(HLF_SESSION);
  if (!session) setCookie(HLF_SESSION, generateGUID());
};

export const setHLFCookies = () => {
  setIdentityCookie();
  setSessionCookie();
};

export const removeHLFCookies = () => {
  deleteCookie(HLF_IDENTITY);
  deleteCookie(HLF_SESSION);
};
